import React from 'react'

const S = {
  wrap: { maxWidth: 800, margin: '0 auto', padding: '3rem 1.5rem 5rem', fontFamily: "'DM Sans', sans-serif", color: '#1a1a1a', lineHeight: 1.8 },
  h1: { fontSize: '2rem', fontWeight: 700, marginBottom: '.5rem', color: '#1a3c2b' },
  sub: { color: '#666', fontSize: '.9rem', marginBottom: '2.5rem' },
  h2: { fontSize: '1.15rem', fontWeight: 700, marginTop: '2rem', marginBottom: '.5rem', color: '#1a3c2b' },
  p: { marginBottom: '1rem', color: '#333' },
  ul: { paddingLeft: '1.5rem', marginBottom: '1rem', color: '#333' },
  li: { marginBottom: '.4rem' },
  box: { background: '#f0faf4', border: '1px solid #b7e4c7', borderRadius: 10, padding: '1rem 1.25rem', marginBottom: '1.5rem' },
}

export default function RefundPolicy() {
  return (
    <div style={S.wrap}>
      <h1 style={S.h1}>Refund Policy</h1>
      <p style={S.sub}>Last updated: June 2026 &nbsp;·&nbsp; Revive Skin &amp; Hair Experts</p>

      <div style={S.box}>
        <strong>Quick summary:</strong> Consultations are refundable if cancelled 2+ hours before. Products are refundable within 7 days if unused and sealed.
      </div>

      <h2 style={S.h2}>1. Consultation Refunds</h2>
      <ul style={S.ul}>
        <li style={S.li}><strong>Cancelled 2+ hours before</strong> — Full refund within 5-7 business days</li>
        <li style={S.li}><strong>Cancelled less than 2 hours before</strong> — No refund (slot cannot be reassigned)</li>
        <li style={S.li}><strong>Doctor unavailable</strong> — Full refund or free rescheduling</li>
        <li style={S.li}><strong>Technical issues on our side</strong> — Full refund or rescheduling</li>
        <li style={S.li}><strong>After consultation is completed</strong> — No refund</li>
      </ul>

      <h2 style={S.h2}>2. Product Refunds</h2>
      <ul style={S.ul}>
        <li style={S.li}><strong>Within 7 days of delivery</strong> — Full refund if product is unused, sealed, and in original packaging</li>
        <li style={S.li}><strong>Damaged or wrong product received</strong> — Full refund or replacement, report within 48 hours of delivery</li>
        <li style={S.li}><strong>Opened or used products</strong> — Not eligible for refund (hygiene reasons)</li>
        <li style={S.li}><strong>After 7 days</strong> — Not eligible for refund</li>
      </ul>

      <h2 style={S.h2}>3. How to Request a Refund</h2>
      <p style={S.p}>To request a refund:</p>
      <ul style={S.ul}>
        <li style={S.li}>Email <strong>support@revivehc.com</strong> with your order/appointment ID</li>
        <li style={S.li}>Or contact us via the <a href="/contact" style={{ color: '#2d6a4f' }}>Contact page</a></li>
        <li style={S.li}>Refunds are processed within 5-7 business days to your original payment method</li>
      </ul>

      <h2 style={S.h2}>4. Shipping Costs</h2>
      <p style={S.p}>Return shipping costs for product refunds are borne by the customer unless the product was damaged or incorrect.</p>

      <h2 style={S.h2}>5. Contact</h2>
      <p style={S.p}>For refund queries contact us at <strong>support@revivehc.com</strong> or call us during clinic hours.</p>
    </div>
  )
}
